const dividerPosition = {
  LEFT: 'left',
  RIGHT: 'right',
  BOTH: 'both',
};

export default dividerPosition;
